export const createOption = (_value, _label) => ({ value: _value, label: _label })

export const periodOptions = [
    createOption(15, 'Últimos 15 dias'),
    createOption(30, 'Últimos 30 dias'),
    createOption(0, 'Personalizado'),
]

export const typeOptions = [createOption(1, 'Crédito'), createOption(2, 'Débito')]
